export default {"src":"/_next/static/media/unsecured-business-overdraft.73d4c203.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};